/* REPORT_TEMPLATE — the complete self-contained audit-report HTML document
   (exact CSS + JS + static skeleton, mirroring the backend report), assembled
   at build time from the split source files below via Vite's `?raw` imports.
   Data regions are tokenized (<!--METADATA-->, <!--CI_ROWS-->, ...) for
   buildAuditReportHtml to fill in.

   The pieces are concatenated in the exact order they originally appeared as
   one document — this is NOT a re-theming of the CSS/JS (verified unsafe: an
   attempt to regroup the CSS by theme changed cascade/specificity outcomes
   and produced a real visual diff). Every file here occupies the same
   position it always did; splitting them out only gets each concern its own
   readable file instead of one multi-thousand-line blob. */
import headOpen from "../template/head-open.html?raw";
import headCloseAndHeader from "../template/head-close-and-header.html?raw";
import metadataAndCatalog from "../template/metadata-and-catalog.html?raw";
import controlAssessmentPanels from "../template/control-assessment-panels.html?raw";
import findingsSnapshotPanel from "../template/findings-snapshot-panel.html?raw";
import findingsAndHistory from "../template/findings-and-history.html?raw";
import assessmentHistoryTable from "../template/assessment-history-table.html?raw";
import networkViewAndEvidenceModal from "../template/network-view-and-evidence-modal.html?raw";
import closing from "../template/closing.html?raw";

import reportCss from "../styles/report.css?raw";

import footerYearJs from "../scripts/footer-year.js?raw";
import controlAssessmentJs from "../scripts/control-assessment.js?raw";
import findingsSnapshotJs from "../scripts/findings-snapshot.js?raw";
import findingsDetailJs from "../scripts/findings-detail.js?raw";
import complianceTrendChartJs from "../scripts/compliance-trend-chart.js?raw";
import assessmentHistoryTabsJs from "../scripts/assessment-history-tabs.js?raw";
import reportJs from "../scripts/report.js?raw";

export const getReportTemplate = (): string =>
  headOpen +
  "<style>" + reportCss + "</style>" +
  headCloseAndHeader +
  "<script>" + footerYearJs + "</script>" +
  metadataAndCatalog +
  "<script>" + controlAssessmentJs + "</script>" +
  controlAssessmentPanels +
  "<script>" + findingsSnapshotJs + "</script>" +
  findingsSnapshotPanel +
  "<script>" + findingsDetailJs + "</script>" +
  findingsAndHistory +
  "<script>" + complianceTrendChartJs + "</script>" +
  assessmentHistoryTable +
  "<script>" + assessmentHistoryTabsJs + "</script>" +
  networkViewAndEvidenceModal +
  "<script>" + reportJs + "</script>" +
  closing;

export const REPORT_TEMPLATE = getReportTemplate();
